// extracted by mini-css-extract-plugin
export default {"productGallery":"XK-z","inQuickShop":"YK-z"};